import React, { FC, forwardRef } from 'react';
import { DisplayTimes } from '../../pages/DateTime';
import TimeCard from '../TimeCard';
import * as S from './styles';

export interface PatientTimeProps {
  times: DisplayTimes[] | undefined;
  onSelectedTime: (time: DisplayTimes) => void;
  selectedTime: DisplayTimes | undefined;
}

const PatientTime = ({ times, onSelectedTime, selectedTime }: PatientTimeProps) => {
  return (
    <S.Container>
      {times?.length ? <S.Info>Horários disponíveis</S.Info> : null}
      <S.ScheduleWrapper>
        {times?.length
          ? times.map(time => (
              <TimeCard
                key={time.id}
                time={time.time}
                active={time?.id === selectedTime?.id}
                onClick={() => {
                  onSelectedTime(time);
                }}
              />
            ))
          : null}
      </S.ScheduleWrapper>
    </S.Container>
  );
};

export default PatientTime;
